import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import CardContent from '@mui/material/CardContent';

const CardSkeleton: React.FunctionComponent = () => (
  <CardContent
    sx={{
      minHeight: { lg: '475px', md: '411px', sm: '411px', xs: '411px' },
      width: { lg: '350px', md: '331px', sm: '331px', xs: '331px' },
      padding: '24px',
      overflow: 'initial',
      borderRadius: '12px',
      boxShadow: (theme) => `-1px 1px 10px 0 ${theme.palette.myShadow.cardLight}`,
    }}
  >
    <Stack spacing={2} direction="column" minHeight="100%">
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Stack spacing={0.5}>
          <Skeleton variant="text" width={91} height={20} />
          <Skeleton variant="text" width={91} height={20} />
        </Stack>
        <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: '8px' }} />
      </Stack>

      <Box sx={{ minHeight: { lg: '125px', md: '107px', sm: '107px', xs: '107px' }, mt: '25px' }}>
        <Skeleton variant="text" width="80%" height={32} />
        <Skeleton variant="text" width="100%" height={24} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="90%" height={24} sx={{ mt: 1 }} />
      </Box>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          gap: '20px',
          p: '27px 0 60px',
        }}
      >
        <Skeleton
          variant="circular"
          sx={{
            width: { lg: 80, md: 60, sm: 60, xs: 60 },
            height: { lg: 80, md: 60, sm: 60, xs: 60 },
          }}
        />
        <Skeleton
          variant="rectangular"
          sx={{
            width: { lg: 48, md: 28, sm: 28, xs: 28 },
            height: { lg: 48, md: 40, sm: 40, xs: 40 },
          }}
        />
        <Skeleton
          variant="circular"
          sx={{
            width: { lg: 80, md: 60, sm: 60, xs: 60 },
            height: { lg: 80, md: 60, sm: 60, xs: 60 },
          }}
        />
      </Stack>

      <Skeleton
        variant="rectangular"
        width="100%"
        sx={{ borderRadius: '8px', height: { lg: 56, md: 46, sm: 46, xs: 46 } }}
      />
    </Stack>
  </CardContent>
);

export default CardSkeleton;
